import { f as flatMap_1 } from './flatMap-db621f8c.js';
import { i as isEmpty_1 } from './isEmpty-ea893565.js';

/**
 * Converts a number to a string representation of the price.
 */
const formatPriceNumber = (price, decimalSeparator, groupingSeparator) => {
    const [whole, fractional] = price.toFixed(2).split('.');
    /* NOSONAR_BEGIN */
    const formattedNumber = whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${groupingSeparator}`);
    /* NOSONAR_END */
    return `${formattedNumber}${decimalSeparator}${fractional}`;
};
/**
 * Appends or prepends currency string.
 */
const addCurrency = (price, currency, currencyPrefix) => {
    const priceData = currencyPrefix ? [currency, price] : [price, currency];
    return priceData.join(' ');
};
/**
 * Generates a string with a formatted price and currency based on the price format.
 */
const formatCustomPrice = (customPrice, priceFormat) => {
    const { price, localizedPrice, currencyCode } = customPrice;
    if (typeof price === 'undefined' && !localizedPrice) {
        return '';
    }
    const { decimalSeparator, groupingSeparator, defaultCurrency, currencyPrefix } = priceFormat;
    const currency = currencyCode || defaultCurrency;
    const priceNumber = localizedPrice
        || (typeof price !== 'undefined' && formatPriceNumber(price, decimalSeparator, groupingSeparator));
    if (!priceNumber) {
        return '';
    }
    return addCurrency(priceNumber, currency, currencyPrefix);
};
const findProductFeedMinimalPrice = (product) => {
    var _a;
    if (!product || !((_a = product === null || product === void 0 ? void 0 : product.RetailerProducts) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
    }
    const stockPrices = flatMap_1(product.RetailerProducts, (retailerProduct) => retailerProduct === null || retailerProduct === void 0 ? void 0 : retailerProduct.StockPrices);
    const prices = stockPrices.map(
    // eslint-disable-next-line @typescript-eslint/naming-convention
    ({ Price }) => Price).filter(Boolean);
    if (!(prices === null || prices === void 0 ? void 0 : prices.length)) {
        return;
    }
    return Math.min(...prices);
};
const weeePricesToTextArray = (weeePrices) => {
    if (isEmpty_1(weeePrices)) {
        return [];
    }
    const { weeePriceLabel, weeeLamp, weeePro, weeePackage } = weeePrices !== null && weeePrices !== void 0 ? weeePrices : {};
    return [weeePriceLabel, weeeLamp, weeePro, weeePackage].filter(Boolean);
};
const applyPriceTemplate = (price, template, placeholder = '#PartnerPrice#') => template.replace(placeholder, price.toString());

export { addCurrency as a, formatCustomPrice as b, findProductFeedMinimalPrice as c, applyPriceTemplate as d, formatPriceNumber as f, weeePricesToTextArray as w };
